import type { ExperienceStatus } from "@intelligems/ig-types/dtos/experiences";

type SortOrder = Record<"started" | "paused" | "pending" | "ended", number>;

const DEFAULT_SORT_ORDER: SortOrder = {
  started: 0,
  paused: 1,
  pending: 2,
  ended: 3,
};

export const sortByStatus = <
  T extends {
    status: ExperienceStatus;
    createdAtTs: number | null;
    startedAtTs: number | null;
  },
>(
  experiences: T[],
  sortOrder: SortOrder = DEFAULT_SORT_ORDER
): T[] => {
  return [...experiences].sort((a, b) => {
    if (a.status === b.status) {
      if (a.status === "pending") {
        return (
          (b.createdAtTs || Number.MAX_VALUE) -
          (a.createdAtTs || Number.MAX_VALUE)
        );
      }

      return (
        (b.startedAtTs || Number.MAX_VALUE) -
        (a.startedAtTs || Number.MAX_VALUE)
      );
    }
    return sortOrder[a.status || "ended"] - sortOrder[b.status || "ended"];
  });
};
